/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Components */
import FocusableButton from '../../../FocusableButton';

/* Utils */
import { noOp } from '../../../../utils/functions';
import { COMPONENTS } from '../../../../utils/focusKey';

/* Styles */
import './GoLive.scss';

function GoLive({
  onEnterPress, isDelayed, hideGoLiveButton, onBecameFocused,
}) {
  return (
    <div className="dtv-html5-c-go-live">
      {!hideGoLiveButton && isDelayed && (
      <FocusableButton
        className="dtv-html5-c-go-live__button"
        onEnterPress={onEnterPress}
        focusKey={COMPONENTS.GO_LIVE_BUTTON}
        onBecameFocused={onBecameFocused}
      >
        <span className="dtv-html5-c-go-live__bullet">&#8226;</span>
        <FormattedMessage
          id="player.watchLive"
          defaultMessage="Ver en vivo"
        />
      </FocusableButton>
      )}
    </div>
  );
}

GoLive.propTypes = {
  onEnterPress: PropTypes.func,
  isDelayed: PropTypes.bool.isRequired,
  hideGoLiveButton: PropTypes.bool,
  onBecameFocused: PropTypes.func,
};

GoLive.defaultProps = {
  onEnterPress: noOp,
  hideGoLiveButton: false,
  onBecameFocused: undefined,
};

export default memo(GoLive);
